import { API_URL } from "env";
import { useState } from "react";

const PermissionAddModal = () => {
    const [displayName, setDisplayName] = useState("");
    const [module, setModule] = useState("");
    const [action, setAction] = useState("");
    const [description, setDescription] = useState("");
    async function handleSubmit() {
        try {
            const response = await fetch(`${API_URL}api/v1/be/permissions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    display_name: displayName,
                    module: module,
                    action: action,
                    description: description,
                    is_active: true,
                }),
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log('Permission created:', data);
        }
        catch (error) {
            console.error('Error creating permission:', error);
        }
    }
    return (
        <div className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto ">
            <div className="flex flex-col gap-2">
                <label htmlFor="permissionName" className="font-medium">Permission Name</label>
                <input type="text" id="permissionName" className="w-full p-2 border rounded-lg" placeholder="Enter permission name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
            </div>
            <div className="flex flex-col gap-2">
                <label htmlFor="module" className="font-medium">Module</label>
                <input type="text" id="module" className="w-full p-2 border rounded-lg" placeholder="Enter module name" value={module} onChange={(e) => setModule(e.target.value)} />
            </div>
            <div className="flex flex-col gap-2">
                <label htmlFor="action" className="font-medium">Action</label>
                <input type="text" id="action" className="w-full p-2 border rounded-lg" placeholder="Enter action name" value={action} onChange={(e) => setAction(e.target.value)} />
            </div>
            <div className="flex flex-col gap-2">
                <label htmlFor="description" className="font-medium">Description</label>
                <textarea id="description" className="w-full p-2 border rounded-lg" placeholder="Enter description" rows={4} value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
            </div>
            <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 !text-white rounded-lg hover:bg-blue-700 transition-colors">
                Create Permission
            </button>
        </div>
    )
}
export default PermissionAddModal;